import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'generalUserLogin',
            component: () => import('@/pages/general_user/Login/Login'),
        },
        {

            path: '/',
            name: 'generalUserLayout',
            component: () => import('@/layouts/general_user/GeneralUserLayout'),
            redirect: 'home',
            children: [
                {
                    path: 'home',
                    name: 'generalUserHome',
                    component: () => import('@/pages/general_user/Home/Home'),
                },

                {
                    path: 'doctors',
                    name: 'generalUserdoctorsList',
                    component: () => import('@/pages/general_user/DoctorsList/DoctorsList'),
                },
                {
                    path: 'activeCall',
                    name: 'generalUserActiveCall',
                    component: () => import('@/pages/general_user/ActiveCall/ActiveCall'),
                },
            ]
        },
        {
            path: '/generalUser/profile',
            name: 'generalUserProfile',
            component: () => import('@/pages/general_user/Profile/Profile'),
        },
        {
            path: '/patient/checkup/:patientcheckup_code',
            name: 'patientCheckup',
            component: () => import('./pages/general_user/Checkup/Checkup'),
        },
        {
            path: '/admin/login',
            name: 'adminLogin',
            component: () => import('@/pages/admin/Login/Login'),
        },
        {
            path: '/admin',
            name: 'adminLayout',
            redirect: '/admin/dashboard',
            component: () => import('@/layouts/admin/AdminLayout'),
            children: [
                {
                    path: 'dashboard',
                    name: 'AnalyticsPage',
                    component: () => import('@/pages/admin/Dashboard/Dashboard'),
                },

                {
                    path: 'error',
                    name: 'Error',
                    component: () => import('@/pages/admin/Error/Error'),
                },
                {
                    path: 'useragent',
                    name: 'UserAgent',
                    component: () => import('@/pages/admin/UserAgent/UserAgent'),
                },
                {
                    path: 'adminpannel',
                    name: 'AdminPannel',
                    component: () => import("@/pages/admin/AdminPannel/AdminPannel"),
                },
                {
                    path: 'Doctor',
                    name: 'doctor',
                    component: () => import('@/pages/admin/Doctor/Doctor'),
                },
                {
                    path: 'typography',
                    name: 'TypographyPage',
                    component: () => import('@/pages/admin/Typography/Typography'),
                },
                {
                    path: 'components/icons',
                    name: 'IconsPage',
                    component: () => import('@/pages/admin/Icons/Icons'),
                },
                {
                    path: 'notifications',
                    name: 'NotificationsPage',
                    component: () => import('@/pages/admin/Notifications/Notifications'),
                },
                {
                    path: 'components/charts',
                    name: 'ChartsPage',
                    component: () => import('@/pages/admin/Charts/Charts'),
                },
                {
                    path: 'tables',
                    name: 'TablesBasicPage',
                    component: () => import('@/pages/admin/Tables/Basic'),
                },
                {
                    path: 'components/maps',
                    name: 'GoogleMapPage',
                    component: () => import('@/pages/admin/Maps/Google'),
                },
            ],
        },
        {
            path: '/doctor/login',
            name: 'doctorLogin',
            component: () => import('./pages/doctor/Login/Login'),
        },
        {
            path: '/doctor/checkup/:patientcheckup_code',
            name: 'doctorCheckup',
            component: () => import('./pages/doctor/Checkup/Checkup'),
        },
        {
            path: '/doctor',
            name: 'doctorLayout',
            redirect: '/doctor/appointments',
            component: () => import('./layouts/doctor/DoctorLayout'),
            children: [

                {
                    path: 'appointments',
                    name: 'doctorAppointments',
                    component: () => import('./pages/doctor/Appointments/Appointments'),
                },
                {
                    path: 'history',
                    name: 'doctorHistory',
                    component: () => import('./pages/doctor/History/History'),
                },
                {
                    path: 'profile',
                    name: 'doctorProfile',
                    component: () => import('./pages/doctor/Profile/Profile'),
                },

            ],
        },
    ],
    scrollBehavior() {
        return {x: 0, y: 0}
    }
});


router.beforeEach((to, from, next) => {

    const publicPages = ['generalUserHome', 'generalUserdoctorsList', 'doctorLogin', 'doctorrequest', 'generalUserLogin', 'adminLogin'];

    const authRequired = !publicPages.includes(to.name);
    // const loggedIn = localStorage.getItem(to.path.split('/')[1]+'User');
    const loggedIn = localStorage.getItem((to.path.startsWith('/doctor/') || to.path.startsWith('/admin/')) ? (to.path.split('/')[1] + 'User') : ('user'));


    // trying to access a restricted page + not logged in
    // redirect to login page
    if (authRequired && !loggedIn) {
        //go to doctor/login or admin/login depending on route url
        next((to.path.startsWith('/doctor/') || to.path.startsWith('/admin/')) ?
            '/' + to.path.split('/')[1] + '/login' : '/login');
    } else {
        next();
    }
});
